import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, Phone } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'Memberships', path: '/memberships' },
    { name: 'Leagues', path: '/leagues' },
    { name: 'Lessons', path: '/lessons' },
    { name: 'Sportsbar', path: '/sportsbar' },
    { name: 'Private Events', path: '/events' },
    { name: "What's New", path: '/whats-new' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/PinHighLogo_NoTagline.png"
              alt="Pin High Golf & Lounge"
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'text-green-600 bg-green-50'
                    : 'text-gray-700 hover:text-green-600 hover:bg-gray-50'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4">
            <a href="tel:4404551078" className="flex items-center gap-2 text-gray-700 hover:text-green-600 transition-colors">
              <Phone className="w-4 h-4" />
              <span className="text-sm font-medium">(440) 455-1078</span>
            </a>
            <Button 
              asChild
              className="bg-green-600 hover:bg-green-700 text-white transition-colors"
            >
              <a href="https://app.whoosh.io/patron/club/pin-high-golf-lounge/agenda/pin-high/today" target="_blank" rel="noopener noreferrer">
                Book Now
              </a>
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-md text-gray-700 hover:text-green-600 hover:bg-gray-100 transition-colors"
            aria-label="Toggle menu"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="lg:hidden border-t border-gray-200 bg-white">
          <div className="px-4 pt-2 pb-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-4 py-3 rounded-md text-base font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-green-600 bg-green-50'
                    : 'text-gray-700 hover:text-green-600 hover:bg-gray-50'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-4 space-y-3">
              <a 
                href="tel:4404551078" 
                className="flex items-center justify-center gap-2 px-4 py-3 text-gray-700 hover:text-green-600 transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span className="text-base font-medium">(440) 455-1078</span>
              </a>
              <Button 
                asChild
                className="w-full bg-green-600 hover:bg-green-700 text-white"
              >
                <a href="https://app.whoosh.io/patron/club/pin-high-golf-lounge/agenda/pin-high/today" target="_blank" rel="noopener noreferrer">
                  Book Now
                </a>
              </Button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;